module.exports = __webpack_public_path__ + "static/media/ratings-table.9065d72d.png";


//////////////////
// WEBPACK FOOTER
// ./src/faq/ratings-table.png
// module id = 2035
// module chunks = 0